export default {
	install(Vue) {
		Vue.prototype.questype = function(callback) {
			// if(sessionStorage.getItem('questypechen')){
			// 	var shopconfig  = JSON.parse(sessionStorage.getItem('questypechen'))
			// 	callback(shopconfig);
			// }else{
				this.$axios({
					url: this.$store.state.p_url + 'tiku/Subject/questionTypeList',
					method: "POST",
					data: {},
					headers: {
						token: localStorage.getItem('token')
					},
				}).then(res => {
					callback(res.data);
					if(Number(res.data.code)==200){
						sessionStorage.setItem('questypechen',JSON.stringify(res.data));	
					}
				})
			// }
		}
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/questype.js